import { useTranslation } from 'react-i18next';
import IntegrationsTable from 'pages/integrations/components/integrationTable/IntegrationsTable';
import { IntegrationCategory } from 'models/InternalIntegrationSetting';
import TabHeader from '../../components/tabHeader/TabHeader';

const IntegrationsListingToolsTab = () => {
  const { t } = useTranslation();

  return (
    <section>
      <TabHeader tabName={t('pageIntegrations.tabNames.listing-tools')} />
      <IntegrationsTable category={IntegrationCategory.LISTING_TOOLS} />
    </section>
  );
};

export default IntegrationsListingToolsTab;
